import { Formik } from 'formik';
import React from 'react';

import { getInitialValues } from '../utils/form';
import { validateScheduleForm } from '../validation/scheduleForm';
import ScheduleStepContent from './ScheduleStepContent';

type Props = {
  lineItemIdList: string[];
};

const ScheduleStep = ({ lineItemIdList }: Props): React.JSX.Element => {
  const initialValues = getInitialValues();

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={(): void => {}}
      validate={validateScheduleForm}
      validateOnChange={false}
      validateOnBlur={false}
      enableReinitialize
    >
      <ScheduleStepContent lineItemIdList={lineItemIdList} />
    </Formik>
  );
};

export default ScheduleStep;
